import { createFileRoute } from '@tanstack/react-router';
import { opportunitiesListOptions, toOpportunitiesQuery } from '@/features/opportunities/list/api';
import { OpportunitiesPage } from '@/features/opportunities/list/OpportunitiesPage';
import { marketsQueryOptions, readStoredMarket, resolveMarketId } from '@/lib/market';
import {
  OPPORTUNITIES_SEARCH_DEFAULTS,
  OpportunitiesSearch,
  stripDefaults,
} from '@/lib/search-schemas';

export const Route = createFileRoute('/_auth/opportunities/')({
  validateSearch: OpportunitiesSearch,
  search: { middlewares: [stripDefaults(OpportunitiesSearch, OPPORTUNITIES_SEARCH_DEFAULTS)] },
  loaderDeps: ({ search }) => search,
  // Préchargement ; les erreurs sont laissées à `useQuery` dans la page (`ErrorState`).
  loader: async ({ context, deps }) => {
    const markets = await context.queryClient
      .ensureQueryData(marketsQueryOptions())
      .catch(() => undefined);
    const marketId = resolveMarketId({
      fromSearch: deps.market,
      stored: readStoredMarket(),
      markets,
    });
    if (!marketId) return;
    await context.queryClient
      .ensureQueryData(opportunitiesListOptions(toOpportunitiesQuery(deps, marketId)))
      .catch(() => undefined);
  },
  component: OpportunitiesPage,
});
